import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import $ from 'jquery';
import {API_ROOT, IMAGE_ROOT, SUB_DOMAIN} from "../api-config";
import fetch from "isomorphic-fetch";
import Color from "color";
import db from "../dbconn";
import axios from "axios";
import Modal from "react-responsive-modal";
import Swal from 'sweetalert2';

class Reset_Password extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            windowHeight: 0,
            open: false,
            redirect404: false,
            swalButton: '',
            randomNumber: this.props.match.params.randomNumber
        };
        this.updateState = this.updateState.bind(this);
    };

    updateState(e) {
        this.setState({});
    }

    componentWillMount() {
        var height = $(window).height();

        this.setState({windowHeight: height});

        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
    }

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };


    toVerify() {

        var customerNewPassword = $('#customerNewPassword').val();
        var customerConfirmPassword = $('#customerConfirmPassword').val();

        if (customerNewPassword == '' ||
            customerNewPassword == null ||
            customerConfirmPassword == '' ||
            customerConfirmPassword == null) {
            this.state.swalButton.fire("Please enter passwords in the fields.");
            return false;


        } else if (customerNewPassword.length < 6) {

            this.state.swalButton.fire({
                title: 'Password must be atleast 6 characters long.',
                allowOutsideClick: false
            });
            return false;

        } else if (customerNewPassword != customerConfirmPassword) {

            this.state.swalButton.fire("Password does not match.");
            return false;

        }

        return true;

    }

    componentDidMount() {

        this.fetchStoreID();

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        $('#home').css('background', 'none');

        $('#submitButton').click(e => {


            if (this.toVerify()) {
                this.onOpenModal();
                axios.post(API_ROOT + '/resetpassword', {
                    customer_password: $('#customerNewPassword').val(),
                    random_number: this.state.randomNumber,
                    store_id: localStorage.getItem("store_id"),
                    merchant_id: localStorage.getItem("merchant_id"),
                })
                    .then((response) => {

                        this.onCloseModal();

                        if (response.data.status === 1) {


                            this.setState({redirect: true});
                        } else {

                            this.state.swalButton.fire(response.data.message);

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            }

        });

    }


    fetchStoreID = () => {

        var url = API_ROOT + '/fetchstoreid?sub_domain=' + SUB_DOMAIN;

        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(storeData => {

                if (storeData.status == 1 && storeData.store_data.length > 0) {


                    localStorage.setItem('store_id', storeData.store_data[0].store_id);
                    localStorage.setItem('store_image', storeData.store_data[0].store_image);
                    localStorage.setItem('store_primary_color', storeData.store_data[0].store_primary_color);
                    localStorage.setItem("store_language",storeData.store_data[0].store_language);
                    var color = Color(storeData.store_data[0].store_primary_color).alpha(0.6).lighten(0.6);
                    localStorage.setItem('store_light_color', color.hex());
                    localStorage.setItem('store_secondary_color', storeData.store_data[0].store_secondary_color);
                    localStorage.setItem('store_button_color', storeData.store_data[0].store_button_color);
                    localStorage.setItem('store_name', storeData.store_data[0].store_button_color);
                    localStorage.setItem('store_address', storeData.store_data[0].store_address);
                    localStorage.setItem('store_city', storeData.store_data[0].store_city);
                    localStorage.setItem('store_state', storeData.store_data[0].store_state);
                    localStorage.setItem('store_zip', storeData.store_data[0].store_zip);
                    localStorage.setItem('store_phone', storeData.store_data[0].store_phone);
                    localStorage.setItem('store_email', storeData.store_data[0].store_email);
                    localStorage.setItem('merchant_id', storeData.store_data[0].merchant_id);

                } else {

                    this.setState({redirect404: true});
                }
            });
    };

    render() {

        const {open} = this.state;
        if (this.state.redirect) {
            return <Redirect to="/password/confirm"/>;
        }
        if (this.state.redirect404) {
            return <Redirect to="/404"/>;
        }

        return (
            <div>
                <div className="left_panel_block" style={{height: '100vh'}}>
                    <div className="left_panel">
                        <div className="left_panel_content">
                            <img src={IMAGE_ROOT + "/images/product/" + localStorage.getItem('store_image')}
                                 alt="Takecharge Dinner Logo"/>
                            <h3 className="text-center">FORGOT YOUR PASSWORD?</h3>
                        </div>
                    </div>
                </div>
                <div className="right_panel h-auto" style={{height: '100vh'}}>
                    <header>
                        <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                            <Link to={'/login'}></Link>
                            <h2 className="text-center m-2-0"><strong>Reset Password</strong></h2>
                        </div>
                    </header>
                    <div className="simple-box scrollClass">
                        <div className="header-title">
                            <h2 className="text-center font-size-20" style={{paddingTop: '50px'}}>RESET PASSWORD</h2>
                        </div>
                        <div className="header-content">
                            <p className="font-family-bold">Please enter new password for the account. </p>
                        </div>
                        <div className="form-box">
                            <div className="form-group">
                                <input type="password" className="form-control" name="" id="customerNewPassword"
                                       placeholder="New Password"/>
                            </div>
                            <div className="form-group">
                                <input type="password" className="form-control" name="" id="customerConfirmPassword"
                                       placeholder="Confirm Password"/>
                            </div>
                            <div className="form-group">
                                <input type="submit" name="submitButton" id="submitButton" value="Change Password"/>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;Resetting...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>

                <div className="clearfix"></div>
            </div>
        );
    }
}

export default Reset_Password;


// WEBPACK FOOTER //
// ./src/view_components/reset_password.js